/**
 * Зоны dashboard.
 *
 * Состав - docs/SPEC.md, 3.1. Зоны разделены вкладками с фиксированной шапкой:
 * у конкурента восемь секций идут подряд в одной прокручиваемой колонке, и
 * нужный блок ищется прокруткой (research/APP_UX_MAP.md, C).
 *
 * ПУСТЫЕ СОСТОЯНИЯ объясняют УСЛОВИЕ появления данных, а не констатируют
 * пустоту (docs/SPEC.md, 2.3): пользователь не должен считать пустой экран
 * поломкой. Поэтому у каждой зоны свой текст, а не общее «Пусто».
 *
 * Зона каналов присутствует как вкладка, но её экран - блок 5: без коннектора
 * подключать нечего.
 */
import type { IconName } from '@efira/ui';

export interface Zone {
  id: string;
  /** Иконка вкладки - Fluent, из src/icons.ts пакета ui. */
  icon: IconName;
  path: string;
  title: string;
  /** Заголовок пустого состояния. */
  emptyTitle: string;
  /** Условие, при котором здесь появятся данные. */
  emptyText: string;
}

export const ZONES: Zone[] = [
  {
    id: 'overlay',
    icon: 'overlay',
    path: '/app/overlay',
    title: 'Overlay',
    emptyTitle: '',
    emptyText: '',
  },
  {
    id: 'stream',
    icon: 'live',
    path: '/app/stream',
    title: 'Эфир',
    emptyTitle: 'Здесь появится управление эфиром',
    emptyText:
      'Подключите TikTok-канал и запустите LIVE — на этой вкладке будут статус подключения, симулятор, статистика и здоровье эфира.',
  },
  {
    id: 'channels',
    icon: 'channel',
    path: '/app/channels',
    title: 'Каналы',
    emptyTitle: 'Здесь появятся ваши TikTok-каналы',
    emptyText:
      'Подключение каналов заработает вместе с TikTok-коннектором. На бесплатном тарифе можно держать три канала, на Pro — без ограничения.',
  },
  {
    id: 'game',
    icon: 'games',
    path: '/app/game',
    title: 'Игра',
    emptyTitle: 'Здесь появится каталог игр',
    emptyText:
      'Как только каталог откроется, игру можно будет запустить в безопасное превью одним кликом — в TikTok при этом ничего не уходит.',
  },
  {
    id: 'bindings',
    icon: 'binding',
    path: '/app/bindings',
    title: 'Привязки',
    emptyTitle: 'Здесь появятся привязки действий',
    emptyText:
      'Выберите игру — и на этой вкладке можно будет назначить, что делает комментарий, подарок, лайк, подписка и репост.',
  },
  {
    id: 'sound',
    icon: 'sound',
    path: '/app/sound',
    title: 'Звук',
    emptyTitle: 'Здесь появится микшер',
    emptyText:
      'Отдельные уровни для звуков игры, музыки, озвучки и алертов появятся, когда запустится первая игра.',
  },
  /*
   * Зона «Раскладка» снята 2026-09-19: редактор переехал в кадр консоли и
   * рисуется поверх живого оверлея. Отдельного экрана у него больше нет -
   * оставлять пункт, ведущий в никуда, значит обещать несуществующее.
   */
];
